import { Component, Input } from '@angular/core';
import {
  AbstractWorkspaceHostComponent,
  AbstractWorkspaceInputs,
} from '../../shared/abstract-workspace-host.component';
import { Submission } from '../../team-apis/otterdam/submission';
import { ReadOnlyWorkspaceComponent } from './read-only-workspace.component';

const readOnlyWorkspaceInputKeys = [
  'projectId',
  'stepId',
  'initialTaskId',
  'submissions',
  'templateId',
] as const;

export type ReadOnlyWorkspaceInputs = Pick<
  ReadOnlyWorkspaceComponent,
  (typeof readOnlyWorkspaceInputKeys)[number]
> &
  AbstractWorkspaceInputs;

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection -- no loading state with on push
@Component({
  selector: 'h3-read-only-workspace-host',
  templateUrl: '../../shared/abstract-workspace-host.component.html',
  standalone: false,
})
export class ReadOnlyWorkspaceHostComponent
  extends AbstractWorkspaceHostComponent<ReadOnlyWorkspaceComponent>
  implements ReadOnlyWorkspaceInputs
{
  @Input({ required: true }) projectId!: number;
  @Input({ required: true }) stepId!: number;
  @Input({ required: true }) initialTaskId!: string;
  @Input({ required: true }) submissions!: Submission[];
  @Input() templateId?: string;

  constructor() {
    super(ReadOnlyWorkspaceComponent, readOnlyWorkspaceInputKeys);
  }

  protected override getProjectId() {
    return this.projectId;
  }
}
